const NAMESPACE = "UI";
const actionType = type => `${NAMESPACE}_${type}`;

export const uiConstants = {
	OPEN_NOTIFICATION: actionType("OPEN_NOTIFICATION"),
	CLOSE_NOTIFICATION: actionType("CLOSE_NOTIFICATION"),

	SHOW_SPINNER_OVERLAY: actionType("SHOW_SPINNER_OVERLAY"),
	HIDE_SPINNER_OVERLAY: actionType("HIDE_SPINNER_OVERLAY"),

	PUSH_MODAL: actionType("PUSH_MODAL"),
	POP_MODAL: actionType("POP_MODAL"),

	SET_IS_ONLINE: actionType("SET_IS_ONLINE"),
};
